import { AbsoluteFill, useCurrentFrame, useVideoConfig } from "remotion";
import {
  dragonFullPath,
  dragonLayout as layout,
  dragonTiming,
  getDragonFrame,
} from "./dragonModel";
import { ease } from "./timeline";
import { CircleDetailInset } from "./components/CircleDetailInset";
import "./style.css";

export const FourierDragon = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const seconds = frame / fps;
  const scene = getDragonFrame(seconds);
  const finish = ease(
    (seconds - dragonTiming.start - dragonTiming.drawing) / 0.9,
  );
  const scale = layout.scale * (1 + 0.04 * finish);
  const donePath = scene.complete.map((s) => s.fullPath).join(" ");
  const transform = `translate(${layout.x} ${layout.y}) scale(${scale}) translate(${-layout.centerX} ${-layout.centerY})`;
  return (
    <AbsoluteFill
      className="fourier-film"
      style={{ backgroundColor: "#080D18", color: "#F4F8FF" }}
    >
      <AbsoluteFill
        style={{
          background:
            "radial-gradient(ellipse at 50% 56%, rgba(29,65,81,0.25), transparent 64%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: 96,
          top: 187,
          fontFamily: "Arial, sans-serif",
          fontSize: 23,
          letterSpacing: 5.4,
          color: "#8B9AAF",
        }}
      >
        LOOP NIBBLE
      </div>
      <div
        style={{
          position: "absolute",
          left: 96,
          top: 310,
          fontSize: 84,
          lineHeight: 1.43,
          fontWeight: 700,
          letterSpacing: -3,
          opacity: 1 - finish,
        }}
      >
        CAN CIRCLES
        <br />
        <span style={{ color: "#FF4FA3" }}>DRAW A DRAGON?</span>
      </div>
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 320,
          width: "100%",
          textAlign: "center",
          fontSize: 76,
          lineHeight: 1.4,
          fontWeight: 700,
          letterSpacing: -2,
          opacity: finish,
        }}
      >
        THIS IS
        <br />
        <span style={{ color: "#FF4FA3" }}>FOURIER TRANSFORM</span>
      </div>
      <svg
        width={1080}
        height={1920}
        viewBox="0 0 1080 1920"
        style={{ position: "absolute", inset: 0 }}
      >
        <defs>
          <filter id="dragon-glow" x="-5%" y="-5%" width="110%" height="110%">
            <feGaussianBlur stdDeviation={2.4} />
          </filter>
          <clipPath id="dragon-stage">
            <rect x={28} y={620} width={1024} height={865} />
          </clipPath>
        </defs>
        <g clipPath="url(#dragon-stage)">
          <g
            transform={transform}
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              d={finish === 1 ? dragonFullPath : donePath}
              stroke="#FF4FA3"
              strokeWidth={5 / scale}
              opacity={0.24}
              filter="url(#dragon-glow)"
            />
            <path
              d={finish === 1 ? dragonFullPath : donePath}
              stroke="#FF6CAF"
              strokeWidth={2.5 / scale}
            />
            {scene.active.map((stroke) => (
              <g key={stroke.id}>
                <path
                  d={stroke.path}
                  stroke="#FFD3E8"
                  strokeWidth={2.8 / scale}
                />
                <g opacity={0.85}>
                  {stroke.chain.map((c) => (
                    <g key={c.frequency}>
                      {c.radius * scale >= 2.5 && (
                        <circle
                          cx={c.center.x}
                          cy={c.center.y}
                          r={c.radius}
                          stroke="#38CDBD"
                          strokeWidth={1 / scale}
                          opacity={0.55}
                        />
                      )}
                      <line
                        x1={c.center.x}
                        y1={c.center.y}
                        x2={c.tip.x}
                        y2={c.tip.y}
                        stroke="#6FEAF2"
                        strokeWidth={1.6 / scale}
                        opacity={0.85}
                      />
                    </g>
                  ))}
                </g>
                <circle
                  cx={stroke.tip.x}
                  cy={stroke.tip.y}
                  r={9 / scale}
                  fill="#FF4FA3"
                  stroke="none"
                  opacity={0.25}
                />
                <circle
                  cx={stroke.tip.x}
                  cy={stroke.tip.y}
                  r={3.7 / scale}
                  fill="#FFF5FA"
                  stroke="none"
                />
              </g>
            ))}
          </g>
        </g>
        {scene.active.length > 0 && (
          <CircleDetailInset chain={scene.active[0].chain} y={1515} />
        )}
      </svg>
      <div
        style={{
          position: "absolute",
          left: 96,
          top: 1550,
          fontSize: 32,
          color: "#8B9AAF",
          letterSpacing: 2,
          opacity: scene.active.length > 0 ? 0 : 1 - finish,
        }}
      >
        EVERY LINE HAS A RHYTHM.
      </div>
    </AbsoluteFill>
  );
};

